"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _app = require("@package/app");

var _profile = require("@widget/profile");

var _moment = _interopRequireDefault(require("@package/moment"));

var _utils = require("@package/utils");

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var NavigateItem = function NavigateItem(props) {
  try {
    var index = props.index,
        item = props.item,
        route = props.route;
    var routePart = item['url'].replace(/^\//, '').split('/')[0];
    var regExp = new RegExp("^".concat(process.env['PUBLIC_URL'], "/").concat(routePart, "((/|/\\w+)|\\b)"), 'i');
    var isActive = regExp.test(route);
    var itemClassName = (0, _classnames["default"])(_defaultModule["default"]['navigate__item'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['navigate__item--active'], isActive));
    var href = "".concat(process.env['PUBLIC_URL']).concat(item['url']);
    var endDate = (0, _moment["default"])(window.env['NEW_LABEL_END_DATE'], 'date').format();
    var today = (0, _moment["default"])().format();
    var ending = (0, _moment["default"])(today).isBefore(endDate);
    return /*#__PURE__*/_react["default"].createElement("span", {
      className: itemClassName,
      key: index,
      "data-locator": "App.navigator-bar.".concat(item['_data'])
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      className: _defaultModule["default"]['navigate__link'],
      to: href
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: (0, _classnames["default"])(_defaultModule["default"]['navigate__icon'], item['icon'])
    }), /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['navigate__title']
    }, item['title']), ending && item['hasNew'] && /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['navigate__badge']
    }, "new")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
};

function Navigate() {
  var _useContext = (0, _react.useContext)(_app.context),
      navigate = _useContext.navigate;

  var location = (0, _reactRouterDom.useLocation)();
  var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
  var permissions = profile.user.permissions,
      type = profile.merchant.type;

  function checkMerchantFlag(flag) {
    var _merchant$status;

    var merchant = profile.merchant;
    var type = merchant === null || merchant === void 0 ? void 0 : merchant.type;
    var statusType = merchant === null || merchant === void 0 ? void 0 : (_merchant$status = merchant.status) === null || _merchant$status === void 0 ? void 0 : _merchant$status.type;
    if (type === 'INDIVIDUAL') return true;
    return ['LEGAL', 'ST'].includes(type) && (merchant === null || merchant === void 0 ? void 0 : merchant[flag]) === true && statusType === 'Moderated';
  }

  var isSubaggregator = checkMerchantFlag('subaggregator');
  var isc2cMarketplace = checkMerchantFlag('c2cMarketplace');

  try {
    return /*#__PURE__*/_react["default"].createElement("nav", {
      className: _defaultModule["default"]['navigate'],
      "data-locator": "App.navigation-bar"
    }, navigate.map(function (item, index) {
      if (item === 'delimiter') {
        return /*#__PURE__*/_react["default"].createElement("span", {
          key: index,
          className: _defaultModule["default"]['delimiter']
        });
      }

      if (item) {
        if ('permissions' in item) {
          var userPermissions = item['permissions'];
          var userType = item['userType'] || null;
          var hasPermission = userPermissions.some(function (perm) {
            return (0, _utils.checkPermission)(permissions, perm);
          });
          var hasUserType = !userType || userType.includes(type) || userType.includes('SUBAGGREGATOR') && isSubaggregator || userType.includes('C2CMARKETPLACE') && isc2cMarketplace;

          if (!hasPermission || !hasUserType) {
            return null;
          }
        }

        return /*#__PURE__*/_react["default"].createElement(NavigateItem, {
          key: index,
          index: index,
          item: {
            _data: item._data || '_',
            icon: item.icon,
            title: item.title,
            url: item.path,
            hasNew: item.hasNew
          },
          route: location['pathname']
        });
      } else {
        return null;
      }
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = Navigate;
exports["default"] = _default;